/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { COLORS } from "./merchants.constants";

export default function MerchantReviewCard({ current }) {
  return (
    <div className="d-flex flex-column align-items-center text-center">
      {current.img && (
        <img
          src={current.img}
          alt={current.name}
          className="rounded-circle mb-3"
          style={{
            width: 90,
            height: 90,
            objectFit: "cover",
            border: `3px solid ${COLORS.gold}`,
            boxShadow: "0 6px 18px rgba(0,0,0,0.3)",
          }}
        />
      )}

      <h5
        className="fw-bold mb-1"
        style={{
          color: COLORS.gold,
          fontSize: "1.25rem",
          fontFamily: "'Cairo', sans-serif",
        }}
      >
        {current.name}
      </h5>

      <p
        className="mb-2"
        style={{
          fontSize: "1rem",
          color: COLORS.textLight,
          opacity: 0.85,
        }}
      >
        {current.store}
      </p>

      <div
        style={{
          color: COLORS.gold,
          fontSize: "1.1rem",
          marginBottom: 12,
        }}
      >
        {"★".repeat(current.rate)}
        {"☆".repeat(5 - current.rate)}
      </div>

      <p
        style={{
          fontSize: "1.1rem",
          color: COLORS.textLight,
          maxWidth: 650,
          lineHeight: 1.8,
          opacity: 0.9,
        }}
      >
        “{current.text}”
      </p>
    </div>
  );
}
